<template>
  <header flex fdc>
    <div class="logo-box" flex fjb fic>
      <router-link to="/" class="logo"></router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: "MainHeader",
};
</script>

<style lang="scss"></style>
